import Header from './Header'
import './LandingPage.css'

const AboutPage = () => {
  /* Services dropdown state and effects moved to Header component */

  return (
    <div className="landing-page about-page">
      <Header />

      {/* Bold Ideas Showcase Section - About Content */}
      <section className="bold-ideas-showcase-section about-hero-section">
        <div className="bold-ideas-star-top-right">
          <img src="/icons BCS-22.svg" alt="Star icon" className="bold-ideas-star-icon" />
        </div>
        <div className="bold-ideas-star-bottom-left">
          <img src="/icons BCS-22.svg" alt="Star icon" className="bold-ideas-star-icon" />
        </div>
        <div className="bold-ideas-showcase-container">
          <div className="bold-ideas-content-left">
            <h2 className="bold-ideas-heading">
              <span className="bold-ideas-heading-green">BRINGING BOLD IDEAS,</span>
              <span className="bold-ideas-heading-green">VISION, AND VIBE TO</span>
              <span className="bold-ideas-heading-purple">YOUR BRAND</span>
            </h2>
            <p className="bold-ideas-description">
              Hey, we're BOLD Creative Studios! We work with brands and businesses who want to stand out. From strategy to visuals, we craft brands that tell stories, turn heads, and leave a mark. Every project is a playground for fierce ideas, fearless creativity, and designs that truly connect.
            </p>
          </div>
          <div className="bold-ideas-image-container">
            <img src="/Posters_on_Fence_Mockup_2.jpg" alt="Bold Ideas Showcase" className="bold-ideas-showcase-image" />
          </div>
        </div>
      </section>

      {/* What Makes Us Different Section */}
      <section className="what-makes-us-different-section">
        <div className="what-makes-us-different-top-icon">
          <img src="/icons BCS-30.svg" alt="Decorative icon" className="what-makes-us-different-icon-img" />
        </div>
        <div className="what-makes-us-different-content">
          <h2 className="what-makes-us-different-headline">WHAT MAKES US DIFFERENT?</h2>
          <p className="what-makes-us-different-tagline">You're not here for designs that just look pretty. You want a brand that turns heads, tells stories, and leaves a lasting mark.</p>
          <div className="what-makes-us-different-text">
            <p className="what-makes-us-different-paragraph">Every brand we craft starts with a deep dive into your vision, your audience, and what makes you fearless and unique. From there, we build a bold, cohesive identity that not only looks unforgettable but works across everything from strategy to visuals, social presence to packaging, and campaigns that demand attention.</p>
            <p className="what-makes-us-different-paragraph">We don't just design – we play, experiment, and push boundaries so your brand doesn't just exist, it stands out, connects, and thrives.</p>
          </div>
        </div>
      </section>

      {/* Meet the Team Section */}
      <section className="meet-the-team-section">
        <div className="meet-the-team-content">
          <p className="new-section-script">The creative minds behind every bold idea.</p>
          <h2 className="meet-the-team-headline">MEET THE TEAM</h2>
          <div className="meet-the-team-grid">
            <div className="meet-the-team-member">
              <div className="meet-the-team-photo">
                <img src="/WhatsApp Image 2025-12-29 at 2.24.13 PM.jpeg" alt="AATRAH" className="meet-the-team-photo-img" />
              </div>
              <h3 className="meet-the-team-name">AATRAH RAUF</h3>
              <p className="meet-the-team-title">FOUNDER & CHIEF EXECUTIVE OFFICER</p>
            </div>
            <div className="meet-the-team-member">
              <div className="meet-the-team-photo">
                <img src="/WhatsApp Image 2025-12-29 at 2.24.11 PM.jpeg" alt="FATIMA" className="meet-the-team-photo-img" />
              </div>
              <h3 className="meet-the-team-name">ZAINAB IRSHAD</h3>
              <p className="meet-the-team-title">SOCIAL MEDIA STRATEGIST</p>
            </div>
            <div className="meet-the-team-member">
              <div className="meet-the-team-photo">
                <img src="/WhatsApp Image 2025-12-29 at 2.24.12 PM (1).jpeg" alt="FARIYAL" className="meet-the-team-photo-img" />
              </div>
              <h3 className="meet-the-team-name">SAWERA YOUSAF</h3>
              <p className="meet-the-team-title"> CREATIVE CONTENT CREATOR</p>
            </div>
            <div className="meet-the-team-member">
              <div className="meet-the-team-photo">
                <img src="/WhatsApp Image 2025-12-29 at 2.24.12 PM.jpeg" alt="ZANEERA" className="meet-the-team-photo-img" />
              </div>
              <h3 className="meet-the-team-name">MEHREEN JUNAID</h3>
              <p className="meet-the-team-title">CREATIVE CONTENT CREATOR <br />& COMMUNITY MANAGER</p>
            </div>
            <div className="meet-the-team-member">
              <div className="meet-the-team-photo">
                <img src="/WhatsApp Image 2025-12-29 at 2.24.14 PM.jpeg" alt="MEHREEN" className="meet-the-team-photo-img" />
              </div>
              <h3 className="meet-the-team-name">FARYAL ALAM</h3>
              <p className="meet-the-team-title"> BRANDING DESIGNER</p>
            </div>
            <div className="meet-the-team-member">
              <div className="meet-the-team-photo">
                <img src="/image.png" alt="Zaneera Shafiq" className="meet-the-team-photo-img" />
              </div>
              <h3 className="meet-the-team-name">ZANEERA SHAFIQ</h3>
              <p className="meet-the-team-title">CREATIVE DESIGNER</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="footer-section">
        <div className="footer-wavy-top">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none" className="wavy-svg wavy-green-2">
            <path d="M0,50 Q60,20 120,50 T240,50 T360,50 T480,50 T600,50 T720,50 T840,50 T960,50 T1080,50 T1200,50 T1320,50 T1440,50 L1440,100 L0,100 Z" fill="#CDD951" />
          </svg>
        </div>
        <div className="footer-star-icon">
          <img src="/icons BCS-44.svg" alt="Star icon" className="footer-star-icon-img" />
        </div>
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/BCS%20LOGO-01%20(1).png" alt="BOLD! CREATIVE STUDIO" className="footer-logo-img" />
          </div>
          <div className="footer-social-icons">
            <a href="https://www.instagram.com/brandingoutloud/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
              <img src="/WEBSITE IMAGES-17.svg" alt="Instagram" className="footer-social-icon-img" />
            </a>
            <a href="https://www.behance.net/brandingoutloud?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnHFYMm_3Cc_qOoIHo5M7pIpJVh1fw7yG_MjUWcetV-lC7sxbyqLSp49vJ22Y_aem_NaED6HYtWH8rqyuMagDYig" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Behance">
              <img src="/WEBSITE IMAGES-18.svg" alt="Behance" className="footer-social-icon-img" />
            </a>
            <a href="https://www.linkedin.com/company/brandingoutloud/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="LinkedIn">
              <div className="footer-social-icon-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#594F9A', borderRadius: '50%', transform: 'scale(0.75)' }}>
                <svg viewBox="0 0 24 24" fill="white" style={{ width: '24px', height: '24px', margin: 0 }}>
                  <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
                </svg>
              </div>
            </a>
            <a href="https://www.facebook.com/share/1879QvWrk8/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
              <img src="/WEBSITE IMAGES-19.svg" alt="Facebook" className="footer-social-icon-img" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default AboutPage

